import { apiEndPoint } from '../config';

function fetchCollection(path) {
    return apiCall('GET', null, path, false)
        .catch(error => {
            throw new Error(error.message, { cause: error.cause });
        })
        .then(resp => {
            if (!resp['hydra:member']) throw new Error(resp, { cause: resp });
            return resp['hydra:member'];
        })
}

function fetchItem(path) {
    return apiCall('GET', null, path, false)
        .catch(error => {
            throw new Error(error.message, { cause: error.cause });
        })
        .then(resp => {
            if (resp["@context"] && resp["@context"] != '/api/contexts/Error')
                return resp;
            else
                throw new Error(resp, { cause: resp });
        })
}

function apiCall(method, data, path, queue) {
    let contentType = 'application/json';
    if (method == 'PATCH') {
        contentType = 'application/merge-patch+json';
    } else if (data && data instanceof FormData) {
        contentType = 'multipart/form-data';
    }

    const requestOptions = {
        method,
        headers: { 'Content-Type': contentType },
    };
    
    if (path == 'api/login_check' || path == 'api/token/refresh') {
        requestOptions.headers.Accept = 'application/json';
    }
    else {
        requestOptions.headers.Authorization = 'Bearer ' + localStorage.getItem('bearerToken');
    }

    if (data && data instanceof FormData) {
        requestOptions.body = data;
        delete requestOptions.headers['Content-Type'];
    } else if (data) {
        requestOptions.body = JSON.stringify(data);
    }
    return fetch(apiEndPoint + path, requestOptions)
        .then(resp => {
            if (resp.ok) {
                return resp.json();
            } else {
                switch (resp.status) {
                    case 500:
                        throw new Error("Erreur serveur", { cause: 500 });
                    case 400:
                        throw new Error("Requête mal formée", { cause: 400 });
                    case 401:
                        throw new Error("Non autorisé, veuillez vous identifier.", { cause: 401 });
                    case 404:
                        throw new Error("Information introuvable", { cause: 404 });
                    default:
                        throw new Error(resp.statusText, { cause: resp.status });
                }
            }
        })
        .catch(error => {
            // Add to queue only if there is some special errors (Network error or Internal server error)
            if ((!error.cause || error.cause === 500 || error.cause === 401) && queue && contentType != 'multipart/form-data') {
                console.log(error);
                const apiQueue = JSON.parse(localStorage.getItem('api_queue') || '[]') || [];
                apiQueue.push({ type: method, data, path })
                localStorage.setItem('api_queue', JSON.stringify(apiQueue));
            }
            if (error.cause) {
                throw new Error(error.message, { cause: error.cause });
            } else {
                throw new Error("Erreur réseau", { cause: 503 });
            }
        })
}

export function getBehhhInfo() {
    const requestOptions = {
        headers: { Accept: 'application/json', Authorization: 'Bearer ' + localStorage.getItem('bearerToken') },
    };
    return fetch(apiEndPoint + 'api/behhh', requestOptions).then(resp => resp.json());
}

export function login(email, password) {
    const data = { username: email, password };
    return apiCall('POST', data, 'api/login_check', false);
}

export function refreshToken() {
    localStorage.setItem('tokenLastRefresh', new Date().getTime());
    const data = { refresh_token: localStorage.getItem('refreshToken') }
    return apiCall('POST', data, 'api/token/refresh', false);
}

async function checkToken() {
    let res = true;
    if (new Date().getTime() - localStorage.getItem('tokenLastRefresh') > 3511000) {
        await refreshToken().then(data => {
            if (typeof data != 'undefined' && data.token) {
                localStorage.setItem('bearerToken', data.token);
                localStorage.setItem('refreshToken', data.refresh_token);
                res = true;
            }
            else {
                res = false;
            }
        })
    }
    return res;
}

export async function addElement(data, path) {
    await checkToken();
    return apiCall('POST', data, path, true);
}
export async function updateElement(data, path) {
    await checkToken();
    return apiCall('PATCH', data, path, true);
}

export function deleteElement(id, path) {
    return apiCall('DELETE', null, path, true);
}

// Animals
export function findAnimals(withArchived) {
    if (withArchived) return fetchCollection('api/animals');
    return fetchCollection('api/animals?exited=0');
}
export function findAnimal(id) {
    return fetchItem('api/animals/' + id);
}
export function addAnimal(data) {
    return addElement(data, 'api/animals');
}
export function updateAnimal(data, id) {
    return updateElement(data, 'api/animals/' + id);
}
export function addAnimalPhoto(data) {
    return addElement(data, 'api/animal_photos');
}
export function findAnimalPhotos(id) {
    return fetchCollection('api/animal_photos?animal=' + id);
}

// Markers
export function findMarkers() {
    return fetchCollection('api/markers');
}
export function findMarker(id) {
    return fetchItem('api/markers/' + id);
}
export function addMarker(data) {
    return addElement(data, 'api/markers');
}
export function updateMarker(data, id) {
    return updateElement(data, 'api/markers/' + id);
}

// Locations
export function findLocations() {
    return fetchCollection('api/locations');
}
export function addLocation(data) {
    return addElement(data, 'api/locations');
}
export function updateLocation(data, id) {
    return updateElement(data, 'api/locations/' + id);
}

// Events
export function findEvents(withArchived) {
    if (withArchived) return fetchCollection('api/events');
    let date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return fetchCollection('api/events?animal.exited=0&date%5Bafter%5D=' + date.toJSON().slice(0, 10));
}
export function findEvent(id) {
    return fetchItem('api/events/' + id);
}
export function addEvent(data) {
    return addElement(data, 'api/events');
}
export function updateEvent(data, id) {
    return updateElement(data, 'api/events/' + id);
}

// Categories
export function findCategories() {
    return fetchCollection('api/categories');
}
export function addCategory(data) {
    return addElement(data, 'api/categories');
}
export function updateCategory(data, id) {
    return updateElement(data, 'api/categories/' + id);
}

// Configs
export function findConfigs() {
    return fetchCollection('api/configs');
}
export function findConfig(id) {
    return fetchItem('api/configs/' + id);
}
export function addConfig(data) {
    return addElement(data, 'api/configs');
}
export function updateConfig(data, id) {
    return updateElement(data, 'api/configs/' + id);
}

// Events type
export function findEventsType() {
    return fetchCollection('api/event_types');
}
export function findEventType(id) {
    return fetchItem('api/event_types/' + id);
}
export function addEventType(data) {
    return addElement(data, 'api/event_types');
}
export function updateEventType(data, id) {
    return updateElement(data, 'api/event_types/' + id);
}
